import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Unity4Claim } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ClaimGuard implements CanActivate {
  constructor(private auth: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const claim: Unity4Claim = next.data.claim;
    return combineLatest([this.auth.isLoggedIn$, this.auth.claims$]).pipe(
      filter(([isLoggedIn, claims]) => !!isLoggedIn && claims.length > 0),
      map(([isLoggedIn, claims]) => claims.includes(claim))
    );
  }
}
